import React from 'react'
import SignUp from '../Components/SignUp/SignUp'
import Header from '../Components/LoginFloder/Header'
const Register = () => {
  return (
    <div>
        <Header />
      <SignUp />
    </div>
  )
}

export default Register
